import React from 'react';
import PropTypes from 'prop-types';
import { ButtonWithIcon } from '@els/els-react--button';

function ChunkPickerDoublePageButton(props) {
  const { onClick, iconClassName, min, max, current } = props;
  const isLeftButton = iconClassName === 'left';

  const handleFirstButtonClick = () => {
    const targetPage = isLeftButton ? min : current + 1;
    return onClick(targetPage);
  };

  const handleLastButtonClick = () => {
    const targetPage = isLeftButton ? current - 1 : max;
    return onClick(targetPage);
  };

  const showFirstButton = isLeftButton ? true : max !== current;
  const showLastButton = isLeftButton ? min !== current : true;

  return (
    <div>
      {showFirstButton && (
        <ButtonWithIcon
          type="link"
          sprite={isLeftButton ? 'JumpToFirst' : 'ChevronRight'}
          iconOnly
          className={`chunk-picker-double-page-button e2e-chunk-picker-double-page-button-${iconClassName}-first`}
          aria-label={`Chunk picker ${iconClassName} first`}
          onClick={handleFirstButtonClick}>
          {`Chunk picker ${iconClassName} first`}
        </ButtonWithIcon>
      )}
      {showLastButton && (
        <ButtonWithIcon
          type="link"
          sprite={isLeftButton ? 'ChevronLeft' : 'JumpToLast'}
          iconOnly
          className={`chunk-picker-double-page-button e2e-chunk-picker-double-page-button-${iconClassName}-last`}
          aria-label={`Chunk picker ${iconClassName} last`}
          onClick={handleLastButtonClick}>
          {`Chunk picker ${iconClassName} last`}
        </ButtonWithIcon>
      )}
    </div>
  );
}

ChunkPickerDoublePageButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  iconClassName: PropTypes.oneOf(['left', 'right']),
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  current: PropTypes.number.isRequired,
};

export default ChunkPickerDoublePageButton;
